const seekText = {
	key: `slider.seek`,
	text: "Seek"
};
//#endregion
export { seekText };

//# sourceMappingURL=slider.js.map